function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { useRef, useState } from 'react';
import IconAddFilled from '~icons/carbon/add-filled';
import { su, theme } from '@arc/frontend/ui-theme';
import { Callout } from './Callout';
import { Menu, MenuButton, MenuItem, MenuList } from './MenuButton';
const styles = {
  addButton: /*#__PURE__*/css(su.textXl, {
    color: theme.colors.text.tableHeader,
    alignSelf: 'center',
    cursor: 'pointer',
    '&[data-disabled=true]': /*#__PURE__*/css({
      color: theme.colors.action.disabledBackground,
      cursor: 'default'
    }, process.env.NODE_ENV === "production" ? "" : ";label:--data-disabled-true-;")
  }, process.env.NODE_ENV === "production" ? "" : ";label:addButton;"),
  addButtonIcon: process.env.NODE_ENV === "production" ? {
    name: "1jvp3p0",
    styles: "height:1.625rem;width:1.625rem"
  } : {
    name: "1hys4lt-addButtonIcon",
    styles: "height:1.625rem;width:1.625rem;label:addButtonIcon;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  }
};
export function AddMenu({
  addOptions,
  addButtonStyles,
  buttonIconStyles,
  label,
  listTestid,
  disabled,
  disabledCalloutText
}) {
  const [showingCallout, setShowingCallout] = useState(false);
  const buttonRef = useRef(null);
  return <>
			<Menu trigger={<MenuButton css={[styles.addButton, addButtonStyles, process.env.NODE_ENV === "production" ? "" : ";label:AddMenu;"]} data-testid="add-menu-button"
    // Use data-disabled because disabled blocks event handlers
    data-disabled={disabled} onClick={e => {
      if (disabled) {
        setShowingCallout(true);
        e.preventDefault();
        e.stopPropagation();
        return;
      }
    }} onMouseLeave={() => setShowingCallout(false)} ref={buttonRef}>
						{label}
						<IconAddFilled css={[styles.addButtonIcon, buttonIconStyles, process.env.NODE_ENV === "production" ? "" : ";label:AddMenu;"]} />
					</MenuButton>}>
				<MenuList data-testid={listTestid}>
					{addOptions.map(option => <MenuItem key={option.key} onSelect={option.onClick} data-testid="add-menu-item">
							{option.label}
						</MenuItem>)}
				</MenuList>
			</Menu>
			{showingCallout && disabledCalloutText ? <Callout targetRef={buttonRef}>{disabledCalloutText}</Callout> : null}
		</>;
}